(() => {
  const key = 'morial-favourites-v1';
  let saved = [];
  try { const data = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(data)) saved = data.filter(item => item && typeof item.key === 'string' && typeof item.title === 'string').slice(0,100); } catch {}
  function imageUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === 'https:' && (url.origin === window.location.origin || url.hostname === 'cdn.shopify.com') ? url.href : null;
    } catch { return null; }
  }
  function announce(state, title) {
    const status = document.getElementById('MorialSaveStatus');
    const dialog = document.getElementById('MorialWishlist');
    const localStatus = dialog instanceof HTMLDialogElement && dialog.open ? dialog.querySelector('[data-morial-wishlist-status]') : null;
    const liveRegion = localStatus || status;
    if (liveRegion && status?.dataset[state]) liveRegion.textContent = status.dataset[state] + (title ? ': ' + title : '');
  }
  function sync() {
    document.querySelectorAll('[data-morial-save]').forEach(button => button.setAttribute('aria-pressed', String(saved.some(item => item.key === button.dataset.morialSave))));
    const list = document.querySelector('[data-morial-wishlist-items]');
    if (!list) return;
    const focusedRemove = document.activeElement?.closest?.('[data-morial-remove]');
    const focusIndex = Array.from(list.querySelectorAll('[data-morial-remove]')).indexOf(focusedRemove);
    const status = document.getElementById('MorialSaveStatus');
    list.replaceChildren();
    const empty = list.closest('dialog')?.querySelector('[data-morial-empty]');
    if (empty) empty.hidden = saved.length > 0;
    for (const item of saved) {
      const row = document.createElement('div'); row.className = 'morial-wishlist__row';
      const source = imageUrl(item.image);
      if (source) { const image = document.createElement('img'); image.src = source; image.alt = ''; image.width = 80; image.height = 80; image.loading = 'lazy'; row.append(image); }
      const link = document.createElement('a'); link.textContent = item.title; link.href = typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//') ? item.url : '/#morial-new'; link.setAttribute('data-morial-close-link',''); row.append(link);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '\u00d7'; remove.setAttribute('aria-label', status?.dataset.remove ? status.dataset.remove + ': ' + item.title : item.title); remove.dataset.morialRemove = item.key; row.append(remove); list.append(row);
    }
    if (focusIndex >= 0) {
      const remaining = list.querySelectorAll('[data-morial-remove]');
      const next = remaining[Math.min(focusIndex, remaining.length - 1)] || list.closest('dialog')?.querySelector('[data-morial-close]');
      next?.focus();
    }
  }
  function persist() { try {localStorage.setItem(key, JSON.stringify(saved));} catch {} sync(); }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const menuLink = target.closest('header-drawer a[href]');
    if (menuLink && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !menuLink.hasAttribute('download') && (!menuLink.target || menuLink.target === '_self')) {
      const drawer = menuLink.closest('header-drawer');
      // Native close releases the focus trap for same-page anchor navigation.
      if (drawer?.isOpen && typeof drawer.close === 'function') drawer.close();
    }
    const opener = target.closest('[data-morial-open]');
    if (opener) { const dialog = document.getElementById(opener.dataset.morialOpen); if (dialog instanceof HTMLDialogElement) { dialog._morialOpener = opener; dialog.showModal(); } }
    const closer = target.closest('[data-morial-close], [data-morial-close-link]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) {
        dialog._morialNavigating = closer.hasAttribute('data-morial-close-link');
        dialog.close();
      }
    }
    if (target instanceof HTMLDialogElement && target.open) {const r = target.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) target.close();}
    const save = target.closest('[data-morial-save]');
    if (save) {
      const found = saved.some(item => item.key === save.dataset.morialSave);
      saved = saved.filter(item => item.key !== save.dataset.morialSave);
      if (!found) saved.push({key:save.dataset.morialSave,title:save.dataset.title,image:save.dataset.image,url:save.dataset.url});
      persist();
      announce(found ? 'removed' : 'saved', save.dataset.title);
    }
    const remove = target.closest('[data-morial-remove]');
    if(remove) {const item=saved.find(item=>item.key===remove.dataset.morialRemove);saved=saved.filter(item=>item.key!==remove.dataset.morialRemove);persist();announce('removed',item?.title);}
  });
  document.addEventListener('close', event => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    if (!event.target._morialNavigating) event.target._morialOpener?.focus({preventScroll:true});
    event.target._morialNavigating = false;
  }, true);
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('storage', event => {if(event.key===key){try{const data=JSON.parse(event.newValue||'[]');saved=Array.isArray(data)?data.filter(item=>item&&typeof item.key==='string'&&typeof item.title==='string').slice(0,100):[];}catch{saved=[];}sync();}});
  sync();
})();

